import React, { useState } from "react";

interface CustomCheckboxProps {
  name: string;
  label: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  customStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  name,
  label,
  checked,
  defaultChecked,
  onChange,
  customStyle,
  labelStyle,
}) => {
  const [isChecked, setIsChecked] = useState(defaultChecked || checked || false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
    if (onChange) onChange(e);
  };

  const containerStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
    ...customStyle,
  };

  const checkboxStyle: React.CSSProperties = {
    width: "20px",
    height: "20px",
    marginRight: "10px",
    border: "1px solid rgb(52, 39, 20)",
    cursor: "pointer",
    appearance: "none",
    backgroundColor: isChecked ? "#c39d63" : "transparent",
    display: "inline-block",
    borderRadius: "3px",
    transition: "background-color 0.2s ease",
  };

  const textStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    color: "rgb(52, 39, 20)",
    fontSize: "1rem",
    cursor: "pointer",
    ...labelStyle,
  };

  return (
    <div style={containerStyle}>
      {/* Checkbox */}
      <input
        id={name}
        name={name}
        type="checkbox"
        checked={checked !== undefined ? checked : isChecked}
        defaultChecked={defaultChecked}
        onChange={handleCheckboxChange}
        style={checkboxStyle}
      />
      {/* Beschreibender Text */}
      <label htmlFor={name} style={textStyle}>
        {label}
      </label>
    </div>
  );
};

export default CustomCheckbox;
